var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllVendor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2091_20474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.477 11.9929L9.14724 2.66572C9.03103 2.46066 8.8625 2.29009 8.65885 2.17142C8.4552 2.05276 8.22371 1.99023 7.98801 1.99023C7.75231 1.99023 7.52082 2.05276 7.31717 2.17142C7.11352 2.29009 6.94499 2.46066 6.82878 2.66572L1.49898 11.9929C1.38151 12.1963 1.31992 12.4272 1.32044 12.6621C1.32096 12.897 1.38358 13.1276 1.50194 13.3305C1.62031 13.5334 1.79022 13.7015 1.99445 13.8175C2.19868 13.9336 2.42997 13.9937 2.66487 13.9915H13.3245C13.5583 13.9913 13.7879 13.9296 13.9902 13.8125C14.1926 13.6955 14.3606 13.5272 14.4774 13.3247C14.5942 13.1222 14.6556 12.8925 14.6556 12.6588C14.6555 12.425 14.5939 12.1953 14.477 11.9929Z",
    stroke: "white",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99475 5.99609V8.66099",
    stroke: "white",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99475 11.3262H8.00141",
    stroke: "white",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2091_20474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllVendor);
export default __webpack_public_path__ + "static/media/all-vendor.7651a96e04a748064d6853ce6bb98405.svg";
export { ForwardRef as ReactComponent };